import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=6ecf81fa&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\dev.marcdeloche.fr\\themes\\marcdeloche\\_dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6ecf81fa', component.options)
    } else {
      api.reload('6ecf81fa', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=6ecf81fa&", function () {
      api.rerender('6ecf81fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/vuejs/components/Product/Gravure/Index.vue"
export default component.exports